export * from './lib/tile.component.module';
